import { render, staticRenderFns } from "./resourcedetils.vue?vue&type=template&id=43c9cb4d&scoped=true"
import script from "./resourcedetils.vue?vue&type=script&lang=js"
export * from "./resourcedetils.vue?vue&type=script&lang=js"
import style0 from "./resourcedetils.vue?vue&type=style&index=0&id=43c9cb4d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c9cb4d",
  null
  
)

export default component.exports